// tslint:disable:max-line-length
import * as React from 'react';
import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
}

export const CheckMarkIcon: React.SFC<IProps> = (props) => {
	const { className } = props;
	return (
		<SvgIcon
			className={ `check-mark-icon ${ className || '' }` }
			height={ 20 }
			width={ 20 }
		>
			<path fillRule='evenodd' clipRule='evenodd' d='M8.169 19L0 11.042l3.571-3.48 3.953 3.852L15.891 0 20 2.858 8.169 19z' fill='#89C947' />
		</SvgIcon>
	);
};
